import { ref, useRoute, onBeforeRouteLeave } from "#imports";
import { UiStyles } from "../../../styles/Styles.js";
import { useConfirmModal } from "./useConfirmModal.js";
export const DefaultConfirmLeaveWithoutSave = [
  { locale: "global.exit_without_save", action: "leave" },
  { locale: "global.save_and_exit", theme: UiStyles.UiTheme.Primary, action: "leaveWithSave" }
];
export const DefaultConfirmStayAndComplete = [
  { locale: "global.stay_and_complete", action: "cancel" },
  { locale: "global.exit_without_save", theme: UiStyles.UiTheme.Primary, action: "leave" }
];
export var ConfirmLeaveAction = /* @__PURE__ */ ((ConfirmLeaveAction2) => {
  ConfirmLeaveAction2["SaveTemplate"] = "save_template";
  ConfirmLeaveAction2["FillRequired"] = "fill_required";
  return ConfirmLeaveAction2;
})(ConfirmLeaveAction || {});
const modalActions = {
  ["save_template" /* SaveTemplate */]: DefaultConfirmLeaveWithoutSave,
  ["fill_required" /* FillRequired */]: DefaultConfirmStayAndComplete
};
export function useConfirmLeave(isNeedSave, isCanSave, onSave, locales, onLeave) {
  const route = useRoute();
  const initPage = route.name;
  const { show: isOpenModal, confirmProps, confirmHandlers } = useConfirmModal();
  const routeNext = ref();
  function leave() {
    routeNext.value();
    if (onLeave) onLeave();
  }
  function cancel() {
    routeNext.value = void 0;
  }
  function showConfirm(activeModal) {
    isOpenModal.value = true;
    confirmProps.value = {
      title: locales && locales[activeModal] && locales[activeModal].title || `report.modals.${activeModal}.title`,
      message: locales && locales[activeModal] && locales[activeModal].message || `report.modals.${activeModal}.message`,
      actions: modalActions[activeModal]
    };
    confirmHandlers.value = {
      leaveWithSave: () => onSave().then(leave),
      leave,
      cancel
    };
  }
  onBeforeRouteLeave((_to, from, next) => {
    if (initPage === from.name && isNeedSave()) {
      routeNext.value = next;
      if (isCanSave()) {
        showConfirm("save_template" /* SaveTemplate */);
      } else {
        showConfirm("fill_required" /* FillRequired */);
      }
    } else {
      next();
    }
  });
  return {
    routeNext
  };
}
